import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

export default function DeleteCaseButton({ caseId, onDeleted, compact = false }) {
  const [open, setOpen] = useState(false);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  const remove = async () => {
    try { await api.delete(`/cases/${caseId}`); toast.success("Contestação excluída"); onDeleted?.(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <button type="button" data-testid={`delete-case-btn-${caseId}`} aria-label="Excluir contestação" onClick={(e) => { stop(e); setOpen(true); }}
        className={compact ? "rounded-lg p-2 text-slate-400 transition-colors hover:bg-red-50 hover:text-red-600"
          : "inline-flex h-10 items-center gap-2 rounded-lg border border-red-200 px-4 text-sm font-semibold text-red-600 transition-colors hover:bg-red-50"}>
        <Trash2 className="h-4 w-4" />{!compact && "Excluir"}
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent onClick={(e) => e.stopPropagation()} data-testid="delete-case-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Excluir esta contestação?</AlertDialogTitle>
            <AlertDialogDescription>A contestação, a defesa gerada e o histórico dela serão apagados. Essa ação não pode ser desfeita.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="delete-case-cancel-btn">Cancelar</AlertDialogCancel>
            <AlertDialogAction data-testid="delete-case-confirm-btn" onClick={remove} className="bg-red-600 hover:bg-red-700">Excluir</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
